import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { tenantSlug } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('fin_token');
    if (token && tenantSlug) {
      axios.get(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}`, 'X-Tenant-Slug': tenantSlug },
      })
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('fin_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [tenantSlug]);

  const login = async (username, senha) => {
    const res = await axios.post(`${API_URL}/api/auth/login`, { username, senha }, {
      headers: { 'X-Tenant-Slug': tenantSlug },
    });
    const { access_token, user: userData } = res.data;
    localStorage.setItem('fin_token', access_token);
    setUser(userData);
    return userData;
  };

  const refreshUser = (updated) => setUser(updated);

  const logout = () => {
    localStorage.removeItem('fin_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);


// ====== SuperAdmin Auth ======

const SuperAdminContext = createContext(null);

export const SuperAdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('fin_sa_token');
    if (token) {
      axios.get(`${API_URL}/api/superadmin/me`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => setAdmin(res.data))
        .catch(() => localStorage.removeItem('fin_sa_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, senha) => {
    const res = await axios.post(`${API_URL}/api/superadmin/auth/login`, { username, senha });
    const { access_token, user: userData } = res.data;
    localStorage.setItem('fin_sa_token', access_token);
    setAdmin(userData);
    return userData;
  };

  const refreshAdmin = (updated) => setAdmin(updated);

  const logout = () => {
    localStorage.removeItem('fin_sa_token');
    setAdmin(null);
  };

  return (
    <SuperAdminContext.Provider value={{ admin, loading, login, logout, refreshAdmin }}>
      {children}
    </SuperAdminContext.Provider>
  );
};

export const useSuperAdmin = () => useContext(SuperAdminContext);
